import * as $ from "jquery";
import Modal from '../../components/generic/modal';

export default class ModalLinkWpl {
  $domRoot: JQuery<HTMLElement>;
  params: any;
  $modalTrigger: any;
  $modalContentContainer: JQuery<any>;
  modalClassname: any;
  $modalHeader: any;
  $modalContent: any;
  modal: any;

  constructor(domRoot: HTMLElement, params: any) {
    this.$domRoot = $(domRoot);
    this.params = {
      useDomRootAsTrigger: false,
      ...params,
    };

    this.$modalTrigger = this.params.useDomRootAsTrigger
      ? this.$domRoot
      : this.$domRoot.find(".modal-link-trigger");
    this.$modalContentContainer = $(this.$modalTrigger.data("target"));
    this.modalClassname = this.$modalContentContainer.data("modal-classname");

    if (this.$modalContentContainer.length) {
      this.$modalHeader = this.$modalContentContainer.find(".modal-header");
      this.$modalContent = this.$modalContentContainer.find(".modal-content");
      this.init();
    }
  }

  init() {
    this.$modalTrigger.on("click", $.proxy(this.onclick, this));

    if (!this.modal) {
      var modalType =
        "dialog" + (this.modalClassname ? " " + this.modalClassname : "");

      this.modal = new Modal({
        modalType: modalType,
        contentClickToHide: false,
      });

      if (this.$modalHeader.length) {
        this.modal.$modalHeader.html(this.$modalHeader.html());
      }
      this.modal.$modalContent.html(this.$modalContent.html());
    }
  }

  trackModalEvent(e: MouseEvent, modalContentContainer) {
    const trackEvent = window?.imkt?.utils?.tracking?.trackEvent;
    const sanitizeEventProps =
      window?.imkt?.utils?.tracking?.sanitizeEventProperties;
    const modalId = modalContentContainer[0]?.id;

    // get label if it's in a feature comparison table
    var featureTextTable = $(e.target)
      .closest("tr")
      .find(".imkt-feature-comparison-table-body-feature-name")
      .text()
      .trim();

    if (featureTextTable.length === 0) featureTextTable = null;

    // get label if it's DOM Root (filter out children/icons)
    var featureTextRoot = $(e.target)
      .clone()
      .children()
      .remove()
      .end()
      .text()
      .trim();

    var featureText = featureTextTable || featureTextRoot;

    if (!modalId || !featureText || !trackEvent || !sanitizeEventProps) {
      return;
    }

    trackEvent(
      "wacModalLinkClicked",
      sanitizeEventProps({
        label: featureText,
        id: modalId,
      })
    );
  }
  
  onclick(e: MouseEvent) {
    e.preventDefault();
    this.trackModalEvent(e, this.$modalContentContainer);
    this.modal.show();
    this.modal.place();
  }
}
